import { Icon } from '@aibees/shared/components';
import { Stack, Typography } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { InfoItemProps as Props } from './types';

export const InfoItem = memo(({ className, icon, title, value }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('InfoItem', className)}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={SX.root}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap={1}
      >
        <Icon name={icon} sxx={SX.icon} size={18} />
        <Typography sx={SX.title}>{title}</Typography>
      </Stack>
      {value}
    </Styled.Wrapper>
  );
});

InfoItem.displayName = 'InfoItem';
